import type { HTMLAttributes } from 'react';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import classes from './index.module.scss';

export interface MentionBaseProps extends HTMLAttributes<HTMLSpanElement> {
  selected?: boolean;
  filled?: boolean;
  dot?: 'hollow' | 'solid';
  user: ChatGroupMember;
}

export default forwardRef(function MentionBase(
  { selected, filled, dot, user, ...attributes }: MentionBaseProps,
  ref: any
) {
  const [user_, _setUser] = useState<ChatGroupMember>(user);

  // useLayoutEffect(() => {
  //   if (propUser) {
  //     setUser(propUser);
  //   }
  // }, [propUser]);

  return (
    <span
      ref={ref}
      {...attributes}
      contentEditable={false}
      className={cls(
        classes.mention_base,
        selected && classes.focus,
        filled && classes.filled,
        dot && classes[dot]
      )}
    >
      @{user_.name}
    </span>
  );
});
